import { Button } from "@/components/ui/button";
import type { ProgressButtonBlockV2 } from "@lib/config/types";
import {
  type FontFamily,
  alignStyle,
  boxShadow,
  resolveFontFamilyVariables,
} from "@lib/utils";
import { useFormState as useReactHookFormState } from "react-hook-form";
import { useFormState as useFormState } from "../forms/landing/form-state-context";

type ProgressButtonProps = ProgressButtonBlockV2;

export function ProgressButton({
  progress_button: submit,
}: ProgressButtonProps) {
  const { isSubmitting: pending } = useReactHookFormState();
  const { validationErrorsWithoutControl } = useFormState();

  const fontFamily = submit.font as FontFamily;

  return (
    <div
      data-block-type="Submit Button"
      style={{
        ...resolveFontFamilyVariables(
          "--button",
          fontFamily,
          submit.font_properties,
        ),
        fontStyle: "var(--button-font-style)",
        fontWeight: "var(--button-font-weight)",
      }}
    >
      {validationErrorsWithoutControl.map(([key, error]) => (
        <p className="text-sm font-medium text-destructive mb-4" key={key}>
          {error}
        </p>
      ))}
      <Button
        type="submit"
        className="px-8 py-0 w-min"
        aria-disabled={pending}
        disabled={pending}
        style={{
          ...alignStyle(submit),
          width: submit.width === "full" ? "100%" : "min-content",
          height: `${submit.height}px`,
          color: submit.color,
          backgroundColor: submit.background,
          borderRadius:
            submit.border.radius === 9999
              ? "9999em"
              : `${submit.border.radius}px`,
          border: `${submit.border.width}px solid ${submit.border.color}`,
          fontSize: submit.font_size,
          fontFamily: "var(--button-font-name)",
          fontWeight: "var(--button-font-weight)",
          letterSpacing: submit.letter_spacing,
          boxShadow: boxShadow(submit.shadow),
        }}
        dangerouslySetInnerHTML={{
          __html: submit.text ?? "",
        }}
      />
    </div>
  );
}
